<template>
  <div class="modal-overlay" v-if="isOpen">
    <div class="modal-item">
      <h3 class="text-center mb30">Konfigurasi</h3>
      <form>
        <label style="margin: 0 0 0 6rem; font-size: small; color: gray;">Keterangan: 1 Hari = 9 Jam</label>
        <div class="form-row">
          <label for="L5" class="text-bold">L5:</label>
          <div class="form-row">
            <label for="startL5hour">Jam:</label>
            <input type="number" id="startL5hour" @input="handleTimeChange" v-model="startL5Hour" min="0"
              class="input-conf" />
            <label for="startL5minute">Menit:</label>
            <input type="number" id="startL5minute" @input="handleTimeChange" v-model="startL5Minute" min="0" max="60"
              class="input-conf" />
          </div>
          <label class="text-center text-bold">s/d</label>
          <div class="form-row">
            <label for="endL5hour">Jam:</label>
            <input type="number" id="endL5hour" @input="handleTimeChange" v-model="endL5Hour" min="0"
              class="input-conf" />
            <label for="endL5minute">Menit:</label>
            <input type="number" id="endL5minute" @input="handleTimeChange" v-model="endL5Minute" min="0" max="60"
              class="input-conf" />
          </div>
        </div>
        <div class="form-row">
          <label for="L4" class="text-bold">L4:</label>
          <div class="form-row">
            <label for="startL5hour">Jam:</label>
            <input type="number" id="startL5hour" @input="handleTimeChange" v-model="startL4Hour" min="0"
              class="input-conf" />
            <label for="startL5minute">Menit:</label>
            <input type="number" id="startL5minute" @input="handleTimeChange" v-model="startL4Minute" min="0" max="60"
              class="input-conf" />
          </div>
          <label class="text-center text-bold">s/d</label>
          <div class="form-row">
            <label for="endL5hour">Jam:</label>
            <input type="number" id="endL5hour" @input="handleTimeChange" v-model="endL4Hour" min="0"
              class="input-conf" />
            <label for="endL5minute">Menit:</label>
            <input type="number" id="endL5minute" @input="handleTimeChange" v-model="endL4Minute" min="0" max="60"
              class="input-conf" />
          </div>
        </div>
        <div class="form-row">
          <label for="L3" class="text-bold">L3:</label>
          <div class="form-row">
            <label for="startL3hour">Jam:</label>
            <input type="number" id="startL3hour" @input="handleTimeChange" v-model="startL3Hour" min="0"
              class="input-conf" />
            <label for="startL3minute">Menit:</label>
            <input type="number" id="startL3minute" @input="handleTimeChange" v-model="startL3Minute" min="0" max="60"
              class="input-conf" />
          </div>
          <label class="text-center text-bold">s/d</label>
          <div class="form-row">
            <label for="endL3hour">Jam:</label>
            <input type="number" id="endL3hour" @input="handleTimeChange" v-model="endL3Hour" min="0"
              class="input-conf" />
            <label for="endL3minute">Menit:</label>
            <input type="number" id="endL3minute" @input="handleTimeChange" v-model="endL3Minute" min="0" max="60"
              class="input-conf" />
          </div>
        </div>

        <div style="margin: 0 auto;">
          <button @click="closeModal" style="padding: .2rem 1rem;">OK</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      startL5Hour: 0,
      startL5Minute: 0,
      endL5Hour: 0,
      endL5Minute: 0,

      startL4Hour: 0,
      startL4Minute: 0,
      endL4Hour: 0,
      endL4Minute: 0,

      startL3Hour: 0,
      startL3Minute: 0,
      endL3Hour: 0,
      endL3Minute: 0,
    }
  },
  mounted() {
    this.setConfig()
  },
  methods: {
    handleTimeChange() {
      if (this.startL5Minute >= 60) {
        const additionalHours = Math.floor(this.startL5Minute / 60)
        this.startL5Hour += additionalHours
        this.startL5Minute = this.startL5Minute % 60
      }
      if (this.endL5Minute >= 60) {
        const additionalHours = Math.floor(this.endL5Minute / 60)
        this.endL5Hour += additionalHours
        this.endL5Minute = this.endL5Minute % 60
      }
      if (this.startL4Minute >= 60) {
        const additionalHours = Math.floor(this.startL4Minute / 60)
        this.startL4Hour += additionalHours
        this.startL4Minute = this.startL4Minute % 60
      }
      if (this.endL4Minute >= 60) {
        const additionalHours = Math.floor(this.endL4Minute / 60)
        this.endL4Hour += additionalHours
        this.endL4Minute = this.endL4Minute % 60
      }
      if (this.startL3Minute >= 60) {
        const additionalHours = Math.floor(this.startL3Minute / 60)
        this.startL3Hour += additionalHours
        this.startL3Minute = this.startL3Minute % 60
      }
      if (this.endL3Minute >= 60) {
        const additionalHours = Math.floor(this.endL3Minute / 60)
        this.endL3Hour += additionalHours
        this.endL3Minute = this.endL3Minute % 60
      }
    },
    async setConfig() {

      try {
        const { data } = await axios({
          method: 'get',
          url: `${api}/api/v1/m-kpi-config?type=1`,
        })

        if (data && data.status == 'success') {
          const getConfig = data.data
          this.startL5Hour = (getConfig.filter(i => i.subname == 'L5')[0].firstValue)
          this.startL5Minute = (getConfig.filter(i => i.subname == 'L5')[0].secondValue)
          this.endL5Hour = (getConfig.filter(i => i.subname == 'L5')[0].thirdValue)
          this.endL5Minute = (getConfig.filter(i => i.subname == 'L5')[0].fourthValue)

          this.startL4Hour = (getConfig.filter(i => i.subname == 'L4')[0].firstValue)
          this.startL4Minute = (getConfig.filter(i => i.subname == 'L4')[0].secondValue)
          this.endL4Hour = (getConfig.filter(i => i.subname == 'L4')[0].thirdValue)
          this.endL4Minute = (getConfig.filter(i => i.subname == 'L4')[0].fourthValue)

          this.startL3Hour = (getConfig.filter(i => i.subname == 'L3')[0].firstValue)
          this.startL3Minute = (getConfig.filter(i => i.subname == 'L3')[0].secondValue)
          this.endL3Hour = (getConfig.filter(i => i.subname == 'L3')[0].thirdValue)
          this.endL3Minute = (getConfig.filter(i => i.subname == 'L3')[0].fourthValue)

          const newData = {
            l5_id: Number(getConfig.filter(i => i.subname == 'L5')[0].id),
            startL5Hour: Number(getConfig.filter(i => i.subname == 'L5')[0].firstValue),
            startL5Minute: Number(getConfig.filter(i => i.subname == 'L5')[0].secondValue),
            endL5Hour: Number(getConfig.filter(i => i.subname == 'L5')[0].thirdValue),
            endL5Minute: Number(getConfig.filter(i => i.subname == 'L5')[0].fourthValue),

            l4_id: Number(getConfig.filter(i => i.subname == 'L4')[0].id),
            startL4Hour: Number(getConfig.filter(i => i.subname == 'L4')[0].firstValue),
            startL4Minute: Number(getConfig.filter(i => i.subname == 'L4')[0].secondValue),
            endL4Hour: Number(getConfig.filter(i => i.subname == 'L4')[0].thirdValue),
            endL4Minute: Number(getConfig.filter(i => i.subname == 'L4')[0].fourthValue),

            l3_id: Number(getConfig.filter(i => i.subname == 'L3')[0].id),
            startL3Hour: Number(getConfig.filter(i => i.subname == 'L3')[0].firstValue),
            startL3Minute: Number(getConfig.filter(i => i.subname == 'L3')[0].secondValue),
            endL3Hour: Number(getConfig.filter(i => i.subname == 'L3')[0].thirdValue),
            endL3Minute: Number(getConfig.filter(i => i.subname == 'L3')[0].fourthValue),

          }

          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: `for_isupplier_value`,
            value: newData
          })
        }


      } catch (error) {
        console.error(error)
      }
    },
    async closeModal() {
      const activePage = this.$get(
        this.$store,
        'state.kpiStore.active_page',
        ''
      )

      const setConfig = {
        ...this.$store.state.kpiStore.for_isupplier_value,
        startL5Hour: this.startL5Hour,
        startL5Minute: this.startL5Minute,
        endL5Hour: this.endL5Hour,
        endL5Minute: this.endL5Minute,
        startL4Hour: this.startL4Hour,
        startL4Minute: this.startL4Minute,
        endL4Hour: this.endL4Hour,
        endL4Minute: this.endL4Minute,
        startL3Hour: this.startL3Hour,
        startL3Minute: this.startL3Minute,
        endL3Hour: this.endL3Hour,
        endL3Minut: this.endL3Minute,
      }

      try {
        await axios({
          method: 'POST',
          url: `${api}/api/v1/m-kpi-config`,
          data: [
            {
              id: setConfig.l5_id,
              firstValue: setConfig.startL5Hour,
              secondValue: setConfig.startL5Minute,
              thirdValue: setConfig.endL5Hour,
              fourthValue: setConfig.endL5Minute,
            },
            {
              id: setConfig.l4_id,
              firstValue: setConfig.startL4Hour,
              secondValue: setConfig.startL4Minute,
              thirdValue: setConfig.endL4Hour,
              fourthValue: setConfig.endL4Minute,
            },
            {
              id: setConfig.l3_id,
              firstValue: setConfig.startL3Hour,
              secondValue: setConfig.startL3Minute,
              thirdValue: setConfig.endL3Hour,
              fourthValue: setConfig.endL3Minute,
            },
          ],
        })

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `for_isupplier_value`,
          value: setConfig,
        })

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: false,
        })
        this.$emit('close')
      } catch (error) {
        console.error(error)
        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: false,
        })
      }
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-item {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 60vw;
}

form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 40vh;
  width: 100%;
  margin: 0 auto;
  /* overflow: auto; */
}

.form-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}

.form-column {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
}

.modal-item input {
  padding: 0.2rem;
  height: 30px;
  width: 60px;
}

.modal-item button {
  padding: 0.1rem 0.5rem;
  background-color: white;
  color: red;
  border: solid 1px red;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px auto;
}

.modal-item button:hover {
  background-color: red;
  color: white;
  border: solid 1px white;
}
</style>
